import { createContext, useState, useEffect } from "react";
import Desktop from "./AppDesktop";
import { PostDesktop } from "../../faetures/fetch";


export const AppContext = createContext();


function AppProviderDesktop({navigate}) {
    const [gates, setGates] = useState({});
    const [dollarGate, setDollarGate] = useState();
    const [timesGates, setTimesGates] = useState(0);
    const [settingsAufa, setSettingsAufa] = useState({});
    const [admin, setAdmin] = useState(false);
    const [aufaData, setAufaData] = useState({});

    useEffect(() => {

        PostDesktop('start', {}).then((resolve) => {
            
            if (typeof resolve === 'object' && resolve !== null && Object.keys(resolve).length > 0 ) {

                if ('gates' in resolve) {
                    setGates(resolve['gates']['rates']);
                    setTimesGates(resolve['gates']['time']);
                    setDollarGate(resolve['gates']['rates']['ILS']);  
                } 

                if ('settings_aufa' in resolve) {
                    setSettingsAufa(resolve['settings_aufa']);
                }

                if ('admin' in resolve) {
                    setAdmin(Boolean(resolve['admin']));
                }

                if ('aufa_data' in resolve) {
                    setAufaData(resolve['aufa_data']);
                }


            } else {
                navigate("/login");
            }
        })

    }, [])

    useEffect(() => {

        let timeoutid = null;

        if (timesGates !== 0) {
            let time_difference = (timesGates * 1000) -  Date.now();

            timeoutid = setTimeout(() => {
                PostDesktop('getRates', {}).then((resolve) => {
                    if (Object.keys(resolve).length > 0) {
                        setGates(resolve['gates']['rates']);
                        setTimesGates(resolve['gates']['time']);   
                        setDollarGate(resolve['gates']['rates']['ILS']);  
                    }
                })
            }, time_difference)
        }

        return () => clearTimeout(timeoutid);
    }, [timesGates]);


    return (
        <AppContext.Provider value={{gates, settingsAufa, admin, dollarGate, aufaData}}>
            <Desktop />
        </AppContext.Provider>
    )
}


export default AppProviderDesktop;